import React from 'react';
import { Stepper, Step, StepLabel, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledStepper = styled(Stepper)(({ theme }) => ({
  '& .MuiStep-root': {
    padding: '8px 0',
  },
  '& .MuiStepLabel-root': {
    cursor: 'pointer',
  },
  '& .MuiStepLabel-label': {
    fontSize: '14px',
    fontWeight: 500,
  },
  '& .MuiStepLabel-active .MuiStepLabel-label': {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  '& .MuiStepLabel-completed .MuiStepLabel-label': {
    color: theme.palette.success.main,
  },
  '& .MuiStepConnector-root': {
    top: 16,
  },
}));

const RecruitmentNavigation = ({ activeStep, steps, onStepClick }) => {
  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <StyledStepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel 
              onClick={() => onStepClick(index)}
              sx={{ 
                '&:hover': { 
                  opacity: 0.8,
                  cursor: 'pointer'
                }
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </StyledStepper>
    </Box>
  );
};

export default RecruitmentNavigation;
